'use client'

import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { TopNavV5DesktopBar } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopBar'
import { TopNavV5DesktopSlidingPanel } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopSlidingPanel'
import { cn } from '@src/utils/tailwind'

export const TopNavV5Desktop = () => {
  const { isExpanded, setExpanded } = useTopNavV5()

  return (
    <nav
      className="relative hidden lg:block"
      id="styled-nav-com-4369"
      onMouseLeave={() => setExpanded(false)}
    >
      <TopNavV5DesktopBar />
      <TopNavV5DesktopSlidingPanel />
      {/* background blur effect */}
      <div
        className={cn('invisible fixed inset-0 z-30 transition-all', {
          'backdrop-blur-sm visible bg-bodi-black-text/80': isExpanded,
        })}
      ></div>
    </nav>
  )
}
